import { render, staticRenderFns } from "./workProposalExport.vue?vue&type=template&id=1f8838f6&scoped=true"
import script from "./workProposalExport.vue?vue&type=script&lang=js"
export * from "./workProposalExport.vue?vue&type=script&lang=js"
import style0 from "./workProposalExport.vue?vue&type=style&index=0&id=1f8838f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8838f6",
  null
  
)

export default component.exports